
export class Announcement {
  constructor(
    public id?: number,
    public title?: string,
    public description?: string,
    public effectiveFromDt?: any,
    public effectiveToDt?: any,
    public priorityCd?: string,
    public providers?: any,
    public recordVersion?: number,
    public validFromDt?: string,
    public validToDt?: string,
    public audienceCd?: String,
    public typeCd?: string,
    public counties?: any,
    public publishedBy?:string
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/announcements.model.ts